import { defineComponent as _defineComponent } from 'vue'
import * as routes from '@/router/route-names'
import {computed,} from 'vue'
import {useStore} from '@/store/store'

interface LinkObject {
  title: string;
  routeName: string;
  icon: string;
  requiresTrue?: () => boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'side-nav',
  props: {
  drawer: {
    type: Boolean,
    required: false,
  }
},
  emits: ['update-drawer'],
  setup(__props, { emit }) {

const props = __props

const store = useStore()




const mainMenuLinks : LinkObject[] = [
  {title: 'Home', routeName: routes.HOME, icon: 'mdi-home', },
  {title: 'Rules', routeName: routes.RULES, icon: 'mdi-format-list-checks', },
]
const leagueLinks : LinkObject[] = [
  {title: 'Admin', routeName: routes.LEAGUE_ADMIN_QUESTIONS, icon: 'mdi-shield', requiresTrue: ()=> isLeagueAdmin.value},
  {title: 'Dashboard', routeName: routes.LEAGUE, icon: 'mdi-view-dashboard', },
  {title: 'Detailed Picks', routeName: routes.LEAGUE_PICKS, icon: 'mdi-table', },
  {title: 'Entries', routeName: routes.LEAGUE_ENTRIES, icon: 'mdi-account-group', },
  {title: 'Hall of Champions', routeName: routes.LEAGUE_CHAMPS, icon: 'mdi-trophy', },
]

const globalAdminLinks : LinkObject[] = [
  {title: 'Global Admin', routeName: routes.GLOBAL_ADMIN, icon: 'mdi-shield', },
]

const getLeague = computed(() => {
  return store.getters.getLeague
})

const getLeagueId = computed(() => {
  return store.getters.getLeagueId
})

const isGlobalAdmin = computed(() => {
  return store.getters.isGlobalAdmin
})

const getUserLeagueIds = computed(() => {
  return store.getters.getUserLeagueIds
})

const getNumberOfLeagues = computed(() => {
  return store.getters.getNumberOfLeagues
})

const getUserLeagues = computed(() => {
  return store.getters.getUserLeagues
})

const isLeagueAdmin = computed(() => {
  if (!getLeague.value) return false
  return getLeague.value.isAnAdmin
})

const drawerInternal = computed({
  get() {
    return props.drawer
  },
  set(newValue) {
    emit('update-drawer', newValue)
  }
})



return { __sfc: true,store, emit, props, mainMenuLinks, leagueLinks, globalAdminLinks, getLeague, getLeagueId, isGlobalAdmin, getUserLeagueIds, getNumberOfLeagues, getUserLeagues, isLeagueAdmin, drawerInternal, routes }
}

})